import {
  InsuranceTypes,
  InsuranceCovers,
  DeductionGroups,
  VehicleTypes,
  InsuranceDurations,
  ExtraFilters,
} from '../enums/filters';

const VehiclesModel = {
  [VehicleTypes.Car]: {
    durations: {
      [InsuranceDurations.OneMonth]: 1,
      [InsuranceDurations.ThreeMonths]: 3,
      [InsuranceDurations.SixMonths]: 6,
      [InsuranceDurations.TwelveMonths]: 12
    },
    [InsuranceTypes.Basic]: {
      // limit this array to 4 items
      cardCovers: [
        InsuranceCovers.RoadsideAssistance,
        InsuranceCovers.LegalProtection,
        InsuranceCovers.CrystalBreakage,
        InsuranceCovers.PersonalAccident,
        InsuranceCovers.NaturalPhenomena,
      ],
      availableFilters: {
        [InsuranceCovers.RoadsideAssistance]: [],
        [InsuranceCovers.LegalProtection]: [],
        [InsuranceCovers.CrystalBreakage]: [],
        [InsuranceCovers.PersonalAccident]: [],
        [InsuranceCovers.NaturalPhenomena]: [],
      },
      extraFilters: [
        ExtraFilters.ShortDrive,
        ExtraFilters.EasyBuy,
        ExtraFilters.Offers,
        ExtraFilters.FriendlySettlement
      ],
      showVehicleValue: true,
    },
    [InsuranceTypes.Extra]: {
      // limit this array to 4 items
      cardCovers: [
        InsuranceCovers.RoadsideAssistance,
        InsuranceCovers.LegalProtection,
        InsuranceCovers.CrystalBreakage,
        InsuranceCovers.Theft,
        InsuranceCovers.NaturalPhenomena,
      ],
      availableFilters: {
        [InsuranceCovers.RoadsideAssistance]: [],
        [InsuranceCovers.LegalProtection]: [],
        [InsuranceCovers.CrystalBreakage]: [],
        [InsuranceCovers.PersonalAccident]: [],
        [InsuranceCovers.PartialTheft]: [],
        [InsuranceCovers.NaturalPhenomena]: [
          InsuranceCovers.NaturalPhenomenaBasic,
          InsuranceCovers.NaturalPhenomenaExtra,
          InsuranceCovers.NaturalPhenomenaPremium,
        ],
      },
      extraFilters: [
        ExtraFilters.ShortDrive,
        ExtraFilters.EasyBuy,
        ExtraFilters.Offers,
        ExtraFilters.FriendlySettlement
      ],
      deductionOptions: DeductionGroups.groupD,
      showVehicleValue: true,
    },
    [InsuranceTypes.Premium]: {
      // limit this array to 4 items
      cardCovers: [
        InsuranceCovers.RoadsideAssistance,
        InsuranceCovers.LegalProtection,
        InsuranceCovers.CrystalBreakage,
        InsuranceCovers.OwnDamages,
        InsuranceCovers.NaturalPhenomena,
      ],
      availableFilters: {
        [InsuranceCovers.RoadsideAssistance]: [],
        [InsuranceCovers.LegalProtection]: [],
        [InsuranceCovers.PersonalAccident]: [],
        [InsuranceCovers.CrystalBreakage]: [],
        [InsuranceCovers.MaliciousPersonalInjury]: [],
        [InsuranceCovers.NaturalPhenomena]: [
          InsuranceCovers.NaturalPhenomenaBasic,
          InsuranceCovers.NaturalPhenomenaExtra,
          InsuranceCovers.NaturalPhenomenaPremium,
        ],
      },
      extraFilters: [
        ExtraFilters.EasyBuy,
        ExtraFilters.Offers,
        ExtraFilters.FriendlySettlement,
      ],
      deductionOptions: DeductionGroups.groupE,
      showVehicleValue: true,
    },
  },
  [VehicleTypes.Bike]: {
    durations: {
      [InsuranceDurations.OneMonth]: 1,
      [InsuranceDurations.ThreeMonths]: 3,
      [InsuranceDurations.SixMonths]: 6,
      [InsuranceDurations.TwelveMonths]: 12
    },
    [InsuranceTypes.Basic]: {
      // limit this array to 4 items
      cardCovers: [
        InsuranceCovers.RoadsideAssistance,
        InsuranceCovers.LegalProtection,
        InsuranceCovers.PersonalAccident,
        InsuranceCovers.DamagesFromUninsuredVehicle,
        InsuranceCovers.NaturalPhenomena,
      ],
      availableFilters: {
        [InsuranceCovers.RoadsideAssistance]: {},
        [InsuranceCovers.LegalProtection]: {},
        [InsuranceCovers.DamagesFromUninsuredVehicle]: {},
        [InsuranceCovers.PersonalAccident]: {},
        [InsuranceCovers.NaturalPhenomena]: [],
      },
      extraFilters: [
        ExtraFilters.EasyBuy,
        ExtraFilters.Offers,
        ExtraFilters.FriendlySettlement
      ],
      showVehicleValue: true,
    },
    [InsuranceTypes.Extra]: {
      // limit this array to 4 items
      cardCovers: [
        InsuranceCovers.RoadsideAssistance,
        InsuranceCovers.LegalProtection,
        InsuranceCovers.Theft,
        InsuranceCovers.DamagesFromUninsuredVehicle,
        InsuranceCovers.NaturalPhenomena,
      ],
      availableFilters: {
        [InsuranceCovers.RoadsideAssistance]: {},
        [InsuranceCovers.LegalProtection]: {},
        [InsuranceCovers.NaturalPhenomena]: {},
        [InsuranceCovers.Theft]: {},
        [InsuranceCovers.NaturalPhenomena]: [
          InsuranceCovers.NaturalPhenomenaBasic,
          InsuranceCovers.NaturalPhenomenaExtra,
          InsuranceCovers.NaturalPhenomenaPremium,
        ],
      },
      extraFilters: [
        ExtraFilters.EasyBuy,
        ExtraFilters.Offers,
        ExtraFilters.FriendlySettlement
      ],
      showVehicleValue: true,
    },
  },
  [VehicleTypes.Truck]: {
    durations: {
      [InsuranceDurations.OneMonth]: 1,
      [InsuranceDurations.ThreeMonths]: 3,
      [InsuranceDurations.SixMonths]: 6,
      [InsuranceDurations.TwelveMonths]: 12
    },
    [InsuranceTypes.Basic]: {
      // limit this array to 4 items
      cardCovers: [
        InsuranceCovers.RoadsideAssistance,
        InsuranceCovers.LegalProtection,
        InsuranceCovers.CrystalBreakage,
        InsuranceCovers.PersonalAccident,
        InsuranceCovers.NaturalPhenomena,
      ],
      availableFilters: {
        [InsuranceCovers.RoadsideAssistance]: {},
        [InsuranceCovers.LegalProtection]: {},
        [InsuranceCovers.CrystalBreakage]: {},
        [InsuranceCovers.PersonalAccident]: {},
        [InsuranceCovers.NaturalPhenomena]: [],
      },
      extraFilters: [
        ExtraFilters.EasyBuy,
        ExtraFilters.Offers,
        ExtraFilters.FriendlySettlement
      ],
      showVehicleValue: true,
    },
    [InsuranceTypes.Extra]: {
      // limit this array to 4 items
      cardCovers: [
        InsuranceCovers.RoadsideAssistance,
        InsuranceCovers.LegalProtection,
        InsuranceCovers.CrystalBreakage,
        InsuranceCovers.Theft,
        InsuranceCovers.NaturalPhenomena,
      ],
      availableFilters: {
        [InsuranceCovers.RoadsideAssistance]: {},
        [InsuranceCovers.LegalProtection]: {},
        [InsuranceCovers.CrystalBreakage]: {},
        [InsuranceCovers.PersonalAccident]: {},
        [InsuranceCovers.PartialTheft]: {},
        [InsuranceCovers.NaturalPhenomena]: {},
        [InsuranceCovers.NaturalPhenomena]: [
          InsuranceCovers.NaturalPhenomenaBasic,
          InsuranceCovers.NaturalPhenomenaExtra,
          InsuranceCovers.NaturalPhenomenaPremium,
        ],
      },
      extraFilters: [
        ExtraFilters.EasyBuy,
        ExtraFilters.Offers,
        ExtraFilters.FriendlySettlement
      ],
      deductionOptions: DeductionGroups.groupD,
      showVehicleValue: true,
    },
    [InsuranceTypes.Premium]: {
      // limit this array to 4 items
      cardCovers: [
        InsuranceCovers.RoadsideAssistance,
        InsuranceCovers.LegalProtection,
        InsuranceCovers.CrystalBreakage,
        InsuranceCovers.OwnDamages,
        InsuranceCovers.NaturalPhenomena,
      ],
      availableFilters: {
        [InsuranceCovers.RoadsideAssistance]: {},
        [InsuranceCovers.LegalProtection]: {},
        [InsuranceCovers.PersonalAccident]: {},
        [InsuranceCovers.CrystalBreakage]: {},
        [InsuranceCovers.MaliciousPersonalInjury]: {},
        [InsuranceCovers.NaturalPhenomena]: [
          InsuranceCovers.NaturalPhenomenaBasic,
          InsuranceCovers.NaturalPhenomenaExtra,
          InsuranceCovers.NaturalPhenomenaPremium,
        ],
      },
      extraFilters: [
        ExtraFilters.EasyBuy,
        ExtraFilters.Offers,
        ExtraFilters.FriendlySettlement
      ],
      deductionOptions: DeductionGroups.groupC,
      showVehicleValue: true,
    },
  },
  [VehicleTypes.Rural]: {
    durations: {
      [InsuranceDurations.OneMonth]: 1,
      [InsuranceDurations.ThreeMonths]: 3,
      [InsuranceDurations.SixMonths]: 6,
      [InsuranceDurations.TwelveMonths]: 12
    },
    [InsuranceTypes.Basic]: {
      // limit this array to 4 items
      cardCovers: [
        InsuranceCovers.RoadsideAssistance,
        InsuranceCovers.LegalProtection,
        InsuranceCovers.CrystalBreakage,
        InsuranceCovers.PersonalAccident,
        InsuranceCovers.NaturalPhenomena,
      ],
      availableFilters: {
        [InsuranceCovers.RoadsideAssistance]: {},
        [InsuranceCovers.LegalProtection]: {},
        [InsuranceCovers.CrystalBreakage]: {},
        [InsuranceCovers.PersonalAccident]: {},
        [InsuranceCovers.NaturalPhenomena]: [],
      },
      extraFilters: [
        ExtraFilters.EasyBuy,
        ExtraFilters.Offers,
        ExtraFilters.FriendlySettlement
      ],
      showVehicleValue: true,
    },
    [InsuranceTypes.Extra]: {
      // limit this array to 4 items
      cardCovers: [
        InsuranceCovers.RoadsideAssistance,
        InsuranceCovers.LegalProtection,
        InsuranceCovers.CrystalBreakage,
        InsuranceCovers.Theft,
        InsuranceCovers.NaturalPhenomena,
      ],
      availableFilters: {
        [InsuranceCovers.RoadsideAssistance]: {},
        [InsuranceCovers.LegalProtection]: {},
        [InsuranceCovers.CrystalBreakage]: {},
        [InsuranceCovers.PersonalAccident]: {},
        [InsuranceCovers.PartialTheft]: {},
        [InsuranceCovers.NaturalPhenomena]: [
          InsuranceCovers.NaturalPhenomenaBasic,
          InsuranceCovers.NaturalPhenomenaExtra,
          InsuranceCovers.NaturalPhenomenaPremium,
        ],
      },
      extraFilters: [
        ExtraFilters.EasyBuy,
        ExtraFilters.Offers,
        ExtraFilters.FriendlySettlement
      ],
      deductionOptions: DeductionGroups.groupD,
      showVehicleValue: true,
    },
    [InsuranceTypes.Premium]: {
      // limit this array to 4 items
      cardCovers: [
        InsuranceCovers.RoadsideAssistance,
        InsuranceCovers.LegalProtection,
        InsuranceCovers.CrystalBreakage,
        InsuranceCovers.OwnDamages,
        InsuranceCovers.NaturalPhenomena,
      ],
      availableFilters: {
        [InsuranceCovers.RoadsideAssistance]: {},
        [InsuranceCovers.LegalProtection]: {},
        [InsuranceCovers.PersonalAccident]: {},
        [InsuranceCovers.CrystalBreakage]: {},
        [InsuranceCovers.MaliciousPersonalInjury]: {},
        [InsuranceCovers.NaturalPhenomena]: [
          InsuranceCovers.NaturalPhenomenaBasic,
          InsuranceCovers.NaturalPhenomenaExtra,
          InsuranceCovers.NaturalPhenomenaPremium,
        ],
      },
      extraFilters: [
        ExtraFilters.EasyBuy,
        ExtraFilters.Offers,
        ExtraFilters.FriendlySettlement
      ],
      deductionOptions: DeductionGroups.groupC,
      showVehicleValue: true,
    },
  },
  [VehicleTypes.Taxi]: {
    durations: {
      [InsuranceDurations.ThreeMonths]: 3,
      [InsuranceDurations.SixMonths]: 6,
      [InsuranceDurations.TwelveMonths]: 12
    },
    [InsuranceTypes.Basic]: {
      // limit this array to 4 items
      cardCovers: [
        InsuranceCovers.RoadsideAssistance,
        InsuranceCovers.LegalProtection,
        InsuranceCovers.CrystalBreakage,
        InsuranceCovers.PersonalAccident,
        InsuranceCovers.NaturalPhenomena,
      ],
      availableFilters: {
        [InsuranceCovers.RoadsideAssistance]: {},
        [InsuranceCovers.LegalProtection]: {},
        [InsuranceCovers.CrystalBreakage]: {},
        [InsuranceCovers.PersonalAccident]: {},
        [InsuranceCovers.NaturalPhenomena]: [],
      },
      extraFilters: [
        ExtraFilters.EasyBuy,
        ExtraFilters.Offers,
        ExtraFilters.FriendlySettlement
      ],
      showVehicleValue: true,
    },
    [InsuranceTypes.Extra]: {
      // limit this array to 4 items
      cardCovers: [
        InsuranceCovers.RoadsideAssistance,
        InsuranceCovers.LegalProtection,
        InsuranceCovers.CrystalBreakage,
        InsuranceCovers.Theft,
        InsuranceCovers.NaturalPhenomena,
      ],
      availableFilters: {
        [InsuranceCovers.RoadsideAssistance]: {},
        [InsuranceCovers.LegalProtection]: {},
        [InsuranceCovers.CrystalBreakage]: {},
        [InsuranceCovers.PersonalAccident]: {},
        [InsuranceCovers.PartialTheft]: {},
        [InsuranceCovers.NaturalPhenomena]: [
          InsuranceCovers.NaturalPhenomenaBasic,
          InsuranceCovers.NaturalPhenomenaExtra,
          InsuranceCovers.NaturalPhenomenaPremium,
        ],
      },
      extraFilters: [
        ExtraFilters.EasyBuy,
        ExtraFilters.Offers,
        ExtraFilters.FriendlySettlement
      ],
      deductionOptions: DeductionGroups.groupD,
      showVehicleValue: true,
    },
  },
  [VehicleTypes.RentalCar]: {
    durations: {
      [InsuranceDurations.OneMonth]: 1,
      [InsuranceDurations.ThreeMonths]: 3,
      [InsuranceDurations.SixMonths]: 6,
      [InsuranceDurations.TwelveMonths]: 12
    },
    [InsuranceTypes.Basic]: {
      // limit this array to 4 items
      cardCovers: [
        InsuranceCovers.RoadsideAssistance,
        InsuranceCovers.LegalProtection,
        InsuranceCovers.CrystalBreakage,
        InsuranceCovers.PersonalAccident,
        InsuranceCovers.NaturalPhenomena,
      ],
      availableFilters: {
        [InsuranceCovers.RoadsideAssistance]: {},
        [InsuranceCovers.LegalProtection]: {},
        [InsuranceCovers.CrystalBreakage]: {},
        [InsuranceCovers.PersonalAccident]: {},
        [InsuranceCovers.NaturalPhenomena]: [],
      },
      extraFilters: [],
      showVehicleValue: true,
    },
    [InsuranceTypes.Extra]: {
      // limit this array to 4 items
      cardCovers: [
        InsuranceCovers.RoadsideAssistance,
        InsuranceCovers.LegalProtection,
        InsuranceCovers.CrystalBreakage,
        InsuranceCovers.PartialTheft,
        InsuranceCovers.NaturalPhenomena,
      ],
      availableFilters: {
        [InsuranceCovers.RoadsideAssistance]: {},
        [InsuranceCovers.LegalProtection]: {},
        [InsuranceCovers.CrystalBreakage]: {},
        [InsuranceCovers.PersonalAccident]: {},
        [InsuranceCovers.PartialTheft]: {},
        [InsuranceCovers.NaturalPhenomena]: [
          InsuranceCovers.NaturalPhenomenaBasic,
          InsuranceCovers.NaturalPhenomenaExtra,
          InsuranceCovers.NaturalPhenomenaPremium,
        ],
      },
      extraFilters: [],
      showVehicleValue: true,
    },
    [InsuranceTypes.Premium]: {
      // limit this array to 4 items
      cardCovers: [
        InsuranceCovers.RoadsideAssistance,
        InsuranceCovers.LegalProtection,
        InsuranceCovers.CrystalBreakage,
        InsuranceCovers.OwnDamages,
        InsuranceCovers.NaturalPhenomena,
      ],
      availableFilters: {
        [InsuranceCovers.RoadsideAssistance]: {},
        [InsuranceCovers.LegalProtection]: {},
        [InsuranceCovers.PersonalAccident]: {},
        [InsuranceCovers.CrystalBreakage]: {},
        [InsuranceCovers.MaliciousPersonalInjury]: {},
        [InsuranceCovers.NaturalPhenomena]: [
          InsuranceCovers.NaturalPhenomenaBasic,
          InsuranceCovers.NaturalPhenomenaExtra,
          InsuranceCovers.NaturalPhenomenaPremium,
        ],
      },
      extraFilters: [],
      deductionOptions: DeductionGroups.groupE,
      showVehicleValue: true,
    },
  },
};

export { VehiclesModel };
